export const addDecimal = (firstValue: number, addend: number, max = Number.MAX_SAFE_INTEGER, precision = 1) =>
  Math.min(max, parseFloat((firstValue + addend).toFixed(precision)));

export const subtractDecimal = (minuend: number, subtrahend: number, min = Number.MIN_SAFE_INTEGER, precision = 1) =>
  Math.max(min, parseFloat((minuend - subtrahend).toFixed(precision)));
